import { Component, OnInit } from '@angular/core';
import {SearchService} from '../../services/search.service';

@Component({
  selector: 'app-display-search-criterias',
  templateUrl: './display-search-criterias.component.html',
  styleUrls: ['./display-search-criterias.component.css']
})
export class DisplaySearchCriteriasComponent {
  constructor(public searchService: SearchService) { }
}
